import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import BrowserOnly from 'components/consumer/BrowserOnly';
const RecentlyViewed = loadable(() => import('components/consumer/recently-viewed'));
const CategoryBestSellersCarousel = loadable(() => import('components/consumer/ProductCardCarousel/CategoryBestSellersCarousel'));

// CON-7309: Temporarily removed to help isolate cause of performance issues
// const RecommendedForYouCarousel = loadable(() =>
//   import('components/consumer/ProductCardCarousel/RecommendedForYouCarousel')
// );

const ProductListingPageWidgets = t0 => {
  const $ = _c(5);
  const {
    categoryId,
    loading: t1
  } = t0;
  const loading = t1 === undefined ? false : t1;
  if (loading) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="py-10 2xl:py-16"><SuspenseWithLoader><RecentlyViewed /></SuspenseWithLoader></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== categoryId) {
    t3 = !!categoryId && <SuspenseWithLoader><CategoryBestSellersCarousel categoryId={parseInt(categoryId, 10)} /></SuspenseWithLoader>;
    $[1] = categoryId;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <BrowserOnly>{t2}{t3}</BrowserOnly>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
ProductListingPageWidgets.propTypes = {
  categoryId: PropTypes.number,
  loading: PropTypes.bool
};
export default ProductListingPageWidgets;